@if (providerProduct && !showIncorrectVariantMatching) {
  <div class="w-full      h-full">
    <ul class="list-none p-0 m-0 mb-2 flex flex-col gap-1 md:flex-row">
      <li (click)="tabStatus = 0" class="relative mr-0 md:mr-20 flex-auto">
        <div
          class=" rounded-border p-4 bg-surface-0 dark:bg-surface-800 flex flex-col md:flex-row items-center z-10"
          [ngClass]="tabStatus === 0 ? 'border-2 border-blue-500': 'border border-300'">
          <i
            class="pi pi-check-circle  !text-2xl md:!text-4xl mb-2 md:mb-0 mr-0 md:mr-4"
            [ngClass]="!providerProduct.validation.Name.status && !providerProduct.validation.Price.status  ?
                            '!text-green-500' : '!text-surface-600 dark:text-surface-200'"></i>
          <div>
            <div
              class=" font-medium mb-1 text-center lg:text-left"
              [ngClass]="tabStatus === 0 ? 'text-blue-600': 'text-900'">Temel
            </div>
            <span
              class=" text-sm "
              [ngClass]="!providerProduct.validation.Name.status && !providerProduct.validation.Price.status? 'text-600': 'text-red-500'">
                        @if (providerProduct.validation.Name.status) {
                          {{ providerProduct.validation.Name.Message }}
                        } @else if (providerProduct.validation.Price.status) {
                          {{ providerProduct.validation.Price.Message }}
                        } @else {
                          Tüm işlemler tamam
                        }
                    </span>
          </div>
        </div>
        <div
          class=" absolute top-1/2 left-full bg-surface-300 dark:bg-surface-500 hidden md:block w-6/12"
          style="transform: translateY(-50%); height: 2px"></div>
      </li>

      @if ((providerSettings?.brand?.supporting || providerSettings?.category?.supporting) && providerProduct.Category !== 'MagentyNoCheck') {
        <li (click)="tabStatus = 1" class="relative mr-0 md:mr-20 flex-auto">
          <div
            class=" rounded-border p-4 bg-surface-0 dark:bg-surface-800 flex flex-col md:flex-row items-center z-10"
            [ngClass]="tabStatus === 1 ? 'border-2 border-blue-500': 'border border-300'">
            <i
              class="pi pi-check-circle  !text-2xl md:!text-4xl mb-2 md:mb-0 mr-0 md:mr-4"
              [ngClass]="(!providerProduct.validation.Brand.status && !providerProduct.validation.Category.status && !providerProduct.validation.CategoryAttribute.status)?
                                    '!text-green-500' : '!text-surface-600 dark:text-surface-200'"></i>
            <div>
              <div
                class=" font-medium mb-1 text-center lg:text-left"
                [ngClass]="tabStatus === 1 ? 'text-blue-600': 'text-900'">
                Eşleştirme
              </div>
              <span
                class=" text-sm "
                [ngClass]="(!providerProduct.validation.Brand.status && !providerProduct.validation.Category.status && !providerProduct.validation.CategoryAttribute.status) ? 'text-600': 'text-red-500'">

                                @if (providerProduct.validation.Brand.status) {
                                  {{ providerProduct.validation.Brand.Message }}
                                } @else if (providerProduct.validation.Category.status) {
                                  {{ providerProduct.validation.Category.Message }}
                                } @else if (providerProduct.validation.CategoryAttribute.status) {
                                  {{ providerProduct.validation.CategoryAttribute.Message }}
                                } @else {
                                  Tüm İşlemler Tamam
                                }
                    </span>
            </div>
          </div>
          <div
            class=" absolute top-1/2 left-full bg-surface-300 dark:bg-surface-500 hidden md:block w-6/12"
            style="transform: translateY(-50%); height: 2px"></div>
        </li>
      }
      @if (product.IsVariant && providerProduct.Category !== 'MagentyNoCheck') {
        <li
          class="relative mr-0 md:mr-20 flex-auto " [pTooltip]="'Eşleştirme Kısmını Kontrol Ediniz!'"
          [tooltipDisabled]="(!providerProduct.validation.Category.status  && !providerProduct.validation.CategoryAttribute.status) ">

          <div
            (click)="tabStatus = 2"
            [ngClass]="(providerProduct.validation.Category.status  || providerProduct.validation.CategoryAttribute.status )?  'p-disabled !opacity-100 ' : ''">


            <div
              class=" rounded-border p-4 bg-surface-0 dark:bg-surface-800 flex flex-col md:flex-row items-center z-10"
              [ngClass]="tabStatus === 2 ? 'border-2 border-blue-500': 'border border-300'">
              <i
                class="pi pi-check-circle  !text-2xl md:!text-4xl mb-2 md:mb-0 mr-0 md:mr-4"
                [ngClass]="(!providerProduct.validation.Variant.status && !providerProduct.validation.Category.status && !providerProduct.validation.CategoryAttribute.status) ?
                                        '!text-green-500' : '!text-surface-600 dark:text-surface-200'"></i>
              <div>
                <div
                  class=" font-medium mb-1 text-center lg:text-left"
                  [ngClass]="tabStatus === 2 ? 'text-blue-600': 'text-900'">
                  Varyant
                </div>

                @if (providerProduct.validation.Category.status || providerProduct.validation.CategoryAttribute.status) {
                  <span
                    class=" text-sm  text-red-500">
                                    Lütfen Önce Kategori Eşleştirmesi Yapınız!

                                       </span>
                } @else if (providerProduct.validation.Variant.status) {
                  <span
                    class=" text-sm  text-red-500">
                                    {{ providerProduct.validation.Variant.Message }}
                                        </span>
                } @else {
                  <span
                    class=" text-sm text-surface-600 dark:text-surface-200">
                                    Tüm İşlemler Tamam
                                     </span>
                }

              </div>
            </div>
            <div
              class=" absolute top-1/2 left-full bg-surface-300 dark:bg-surface-500 hidden md:block w-6/12"
              style="transform: translateY(-50%); height: 2px"></div>
          </div>

        </li>
      }
      <li (click)="tabStatus = 3" class="relative flex-auto">
        <div
          class=" rounded-border p-4 flex bg-surface-0 dark:bg-surface-800  flex-col md:flex-row items-center z-10"
          [ngClass]="tabStatus === 3 ? 'border-2 border-blue-500': 'border border-300'">
          <i
            class="pi pi-check-circle  !text-2xl md:!text-4xl  mb-2 md:mb-0 mr-0 md:mr-4"
            [ngClass]="!providerProduct.validation.MarketPlaceSpecial.status  && !providerProduct.validation.ShippingTemplate.status  && !providerProduct.validation.ProviderSku.status ?
                             '!text-green-500' : '!text-surface-600 dark:text-surface-200'"></i>
          <div>
            <div
              class=" font-medium mb-1 text-center lg:text-left"
              [ngClass]="tabStatus === 3 ? 'text-blue-600': 'text-900'">
              Pazaryeri
              Özel
            </div>
            <span
              class=" text-sm "
              [ngClass]="!providerProduct.validation.MarketPlaceSpecial.status  && !providerProduct.validation.ShippingTemplate.status  && !providerProduct.validation.ProviderSku.status ? 'text-600': 'text-red-500'">
                           @if (providerProduct.validation.MarketPlaceSpecial.status) {
                             {{ providerProduct.validation.MarketPlaceSpecial.Message }}
                           } @else if (providerProduct.validation.ShippingTemplate.status) {
                             {{ providerProduct.validation.ShippingTemplate.Message }}
                           } @else if (providerProduct.validation.ProviderSku.status) {
                             {{ providerProduct.validation.ProviderSku.Message }}
                           } @else {
                             Tüm İşlemler Tamam
                           }
                        </span>
          </div>
        </div>
      </li>
    </ul>
    <p-divider></p-divider>
    <div class="bg-surface-50 dark:bg-surface-800 ">
      @if (tabStatus === 0) {
        <div>
          <magenty-provider-product-detail-base
            [providerCategoryAttributes]="providerCategoryAttributes()"
            [providerSettings]="providerSettings" [product]="product"
            [providerProduct]="providerProduct"></magenty-provider-product-detail-base>
        </div>
      } @else if (tabStatus === 1) {
        <magenty-provider-product-detail-matching
          [(newAttributes$)]="newAttributes$"
          [(providerCategoryAttributes)]="providerCategoryAttributes"
          [(matchingAutoComplete)]="matchingAutoComplete"
          [providerSettings]="providerSettings" [product]="product"
          [providerProduct]="providerProduct"></magenty-provider-product-detail-matching>
      } @else if (tabStatus === 2) {
        <magenty-provider-product-detail-variants
          [(providerCategoryAttributes)]="providerCategoryAttributes"
          [(matchingAutoComplete)]="matchingAutoComplete"
          (variantDataSource)="variantDataSource=$event"
          (baseVariants)="baseVariants=$event"
          [eachVariantAProduct]="eachVariantAProduct" [providerSettings]="providerSettings"
          [product]="product"
          [providerProduct]="providerProduct"></magenty-provider-product-detail-variants>
      } @else if (tabStatus === 3) {
        <magenty-provider-product-detail-marketplace-special
          [variantDatasource]="variantDataSource"
          [baseVariants]="baseVariants"
          [providerCategoryAttributes]="providerCategoryAttributes()"
          [eachVariantAProduct]="eachVariantAProduct" (tabStatus)="tabStatus=$event"
          [providerSettings]="providerSettings" [product]="product"
          [providerProduct]="providerProduct"
          (isSave)="isSave = $event"></magenty-provider-product-detail-marketplace-special>

      }

    </div>
  </div>

} @else if (showIncorrectVariantMatching && incorrectVariantMatchingDataSource.length > 0) {


  <div class="bg-surface-0 dark:bg-surface-800 flex flex-col lg:flex-row px-6  md:px-12 lg:px-20 items-center">

    <div
      style="background: url(assets/background/bg-1.jpg)"
      class="w-full bg-no-repeat bg-cover  rounded-xl px-6 py-16 sm:px-16 md:px-12">
      <img
        src="assets/images/blocks/cta/cta-building.png"
        class="w-full sm:w-60 rounded-border block lg:hidden mx-auto mb-8">
      <div class="text-indigo-50 text-4xl font-semibold mb-4">Hatalı Varyant Eşleştirme</div>
      <p class="text-indigo-100 mt-0 mb-8 leading-normal">Lütfen doğru varyant değerlerini seçerek işlemlerinize
        devam edin. Hatalı veya eksik seçimler, işlem sırasında sorunlara yol açabilir. Doğru eşleştirme
        yaparak, işlemlerinizi sorunsuz bir şekilde tamamlayabilirsiniz.</p>
      <button
        type="button" pButton pRipple label="Nasıl Yapılır ?"
        class="p-button-warning px-8 font-bold whitespace-nowrap"></button>
    </div>
  </div>

  <div class="px-6 py-20 md:px-12 lg:px-20">

    <p-table [value]="incorrectVariantMatchingDataSource" [tableStyle]="{ 'min-width': '20rem' }" stripedRows>
      <ng-template #header>
        <tr>
          <th>Varyant Kodu</th>
          <th>Eski Varyant Adı</th>
          <th>Pazaryeri Varyant Adı</th>
          <th>Eski Varyant Değeri</th>
          <th>Pazaryeri Varyant Değeri</th>
          <th>Yeni Varyant Seçimi</th>
        </tr>
      </ng-template>
      <ng-template #body let-product>
        <tr>

          <td>{{ product.VariantItemCode }}</td>

          <td>{{ product.VariantKey }}</td>

          <td>{{ product.Name }}</td>

          <td>{{ product.VariantValue }}</td>

          <td>{{ product.Value }}</td>

          <td>
            <p-select
              (onChange)="variantChange(product,$event.value)"
              [options]="incorrectVariantMatchingList" appendTo="body"
              optionLabel="header"></p-select>

          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="flex   bg-surface-0 dark:bg-surface-800  h-20 gap-2 border-t border-surface pt-4">


    <div class="ml-auto">


      <button
        pButton icon="pi pi-check" [disabled]="incorrectVariantMatchingValidation()" (click)="variantSave()"
        label="Kaydet"></button>


    </div>
  </div>
}
